import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../hooks/useLanguage";
import TermsPopup from "../../../components/Popup/TermsPopup";
import instance from "../../../services/services";
import { TERMS_LIST_URL } from "../../../utils/urls";

function JoinAgreement(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [allChecked, setAllChecked] = useState(false); 
  const [checkboxes, setCheckboxes] = useState({
    option1: false,
    option2: false,
    option3: false,
  });

  // 팝업 상태 추가
  const [isTermsPopup, setIsTermsPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({ title: '', content: '' });

  // 필수 항목이 모두 체크되었는지 확인하는 함수
  const isRequiredChecked = () => {
    return checkboxes.option1 && checkboxes.option2;
  };

  const nextStep = (() => {
    if (isRequiredChecked()) {
      navigate('/joinVerification');
    }
  });

  // 전체 체크박스가 변경되었을 때 나머지 체크박스들을 모두 체크하거나 해제
  const handleAllCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setAllChecked(isChecked);
    setCheckboxes({
      option1: isChecked,
      option2: isChecked,
      option3: isChecked,
    });
  };
  
  // 개별 체크박스가 변경되었을 때 상태 업데이트 및 전체 체크 상태 업데이트
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => {
      const updatedCheckboxes = {
        ...prevCheckboxes,
        [name]: checked,
      };
      // 개별 체크박스가 모두 체크된 경우 전체 체크박스를 true로 설정
      const allCheckedStatus = Object.values(updatedCheckboxes).every(Boolean);
      setAllChecked(allCheckedStatus);
      return updatedCheckboxes;
    });
  };

  // 약관 보기 버튼 클릭 핸들러 수정
  const handleViewTerms = async (type, event) => {
    event.stopPropagation(); // 이벤트 전파 중지
    event.preventDefault(); // 기본 동작 방지
    
    let title = '';
    let dataKey = '';

    switch(type) {
      case 'terms':
        title = '이용약관';
        dataKey = 'agreement';
        break;
      case 'privacy':
        title = '개인정보 수집 및 이용 동의';
        dataKey = 'policy_agreement';
        break;
      case 'marketing':
        title = '쇼핑정보 수신 동의';
        dataKey = 'marketing_agreement';
        break;
      default:
        return;
    }

    try {
      const response = await instance.post(TERMS_LIST_URL);
      
      if (response.data.code === 200) {
        setPopupContent({ 
          title, 
          content: response.data.data[dataKey] || '약관 내용을 불러올 수 없습니다.' 
        });
        setIsTermsPopup(true);
      } else {
        throw new Error(response.data.message || '약관 내용을 불러올 수 없습니다.');
      }
    } catch (error) {
      console.error('약관 내용을 불러오는 중 오류 발생:', error);
      setPopupContent({ 
        title, 
        content: '약관 내용을 불러올 수 없습니다. 잠시 후 다시 시도해주세요.' 
      });
      setIsTermsPopup(true);
    }
  };

  return(
    <div>
      <section className="auth_section ">
          <div className="inner gap_32">
              <div className="section_title">
                  <h3>
                    {t('sign_up')}
                  </h3>
              </div>
              {/* auth_section , inner  , section_title > 회원가입에서 공통으로 써도 될거같아요 >> 주의 : 로그인 이외 페이지에 inner 옆에 클래스명 추가됩니다*/}

              <div className="form_wrap join_con">
                <h6 className="sub_title">{t('terms_of_service_agreement')}</h6>
                
                <div className="default_chk_box all_chk">
                  <input 
                    type="checkbox" 
                    id="allChk" 
                    value="all" 
                    checked={allChecked} 
                    onChange={handleAllCheckboxChange}
                  />
                  <label htmlFor="allChk">
                    <span>{t('all_agree')}</span>
                  </label>
                </div>  
                
                <ul className="form_group">
                  <li className="default_chk_box">
                    <input 
                      type="checkbox"
                      id="useAgree"  
                      name="option1"
                      checked={checkboxes.option1}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="useAgree">
                      <span>
                        {t('terms_of_service_agreement_text')}
                        <div 
                          className="color_g80" 
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => handleViewTerms('terms', e)}
                        >
                          {t('view')}
                        </div>
                      </span>
                    </label>
                  </li>
                  
                  <li className="default_chk_box">
                      <input 
                      type="checkbox" 
                      id="personalAgree" 
                      name="option2"
                      checked={checkboxes.option2}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="personalAgree">
                      <span>
                        {t('personal_info_collection_and_use_agreement')}
                        <div 
                          className="color_g80" 
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => handleViewTerms('privacy', e)}
                        >
                          {t('view')}
                        </div>
                      </span>
                    </label>
                  </li>
                  
                  <li className="default_chk_box">
                    <input 
                      type="checkbox"
                      id="receiveAgree"  
                      name="option3"
                      checked={checkboxes.option3}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="receiveAgree">
                      <span>
                        {t('shopping_info_receipt_agreement')}
                        <div 
                          className="color_g80" 
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => handleViewTerms('marketing', e)}
                        >
                          {t('view')}
                        </div>
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
                
              <button 
                type="button" 
                className={`default_btn black lg ${isRequiredChecked() ? 'black' : 'disabled'}`} 
                onClick={nextStep}
                disabled={!isRequiredChecked()}
              >
                {t('agree_and_sign_up')}
              </button> 
          </div>
      </section>

      {/* 약관 팝업 */}
      <TermsPopup 
        isPopup={isTermsPopup}
        setIsPopup={setIsTermsPopup}
        title={popupContent.title}
        content={popupContent.content}
      />
    </div>
  );
};

export default JoinAgreement;